import { useAuth, RedirectToSignIn } from "@clerk/clerk-react";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  // Pending sessions (signed in, no org yet) count as signed in here so they
  // go to the workspace step instead of back to sign-in.
  const { isSignedIn, isLoaded, orgId } = useAuth({ treatPendingAsSignedOut: false });

  if (!isLoaded) return null;
  if (!isSignedIn) return <RedirectToSignIn />;
  if (!orgId) return <Navigate to="/onboarding/workspace" replace />;

  return <Outlet />;
}
